import 'jquery-validation'
/* import Inputmask from "inputmask/lib/inputmask"; */
import Inputmask from "inputmask";

jQuery(function ($) {
  if (window.language === 'pl') {
    $.extend($.validator.messages, {
      required: "To pole jest wymagane.",
      remote: "Proszę o wypełnienie tego pola.",
      email: "Proszę o podanie prawidłowego adresu email.",
      url: "Proszę o podanie prawidłowego URL.",
      date: "Proszę o podanie prawidłowej daty.",
      dateISO: "Proszę o podanie prawidłowej daty (ISO).",
      number: "Proszę o podanie prawidłowej liczby.",
      digits: "Proszę o podanie samych cyfr.",
      creditcard: "Proszę o podanie prawidłowej karty kredytowej.",
      equalTo: "Proszę o podanie tej samej wartości ponownie.",
      extension: "Proszę o podanie wartości z prawidłowym rozszerzeniem.",
      nipPL: "Proszę o podanie prawidłowego numeru NIP.",
      phonePL: "Proszę o podanie prawidłowego numeru telefonu",
      maxlength: $.validator.format("Proszę o podanie nie więcej niż {0} znaków."),
      minlength: $.validator.format("Proszę o podanie przynajmniej {0} znaków."),
      rangelength: $.validator.format("Proszę o podanie wartości o długości od {0} do {1} znaków."),
      range: $.validator.format("Proszę o podanie wartości z przedziału od {0} do {1}."),
      max: $.validator.format("Proszę o podanie wartości mniejszej bądź równej {0}."),
      min: $.validator.format("Proszę o podanie wartości większej bądź równej {0}."),
      pattern: $.validator.format("Pole zawiera niedozwolone znaki.")
    })
  }

  const inquiryPopupSuccess = document.getElementById('inquiryPopupSuccess')
    ? new bootstrap.Modal(document.getElementById('inquiryPopupSuccess'))
    : null


  const inquiryPopupError = document.getElementById('inquiryPopupError')
    ? new bootstrap.Modal(document.getElementById('inquiryPopupError'))
    : null


  const inputmask = new Inputmask({regex: "[\\d+ ]*"})

  if (document.getElementById('inquiry_phone')) {
    inputmask.mask(document.getElementById('inquiry_phone'))
  }

  function sendInquiry(form) {
    $.ajax({
      method: 'post',
      dataType: 'json',
      data: $(form).serialize(),
      url: settings.ajaxurl,
      success: function (response) {
        $('.btn-inquiry').html($('.btn-inquiry').data('label'))
        $(".variations_form")[0].reset()
        if (response.status === 'ok') {
          inquiryPopupSuccess.show()
        } else {
          inquiryPopupError.show();
        }
      }
    })
  }

  function variationFormValidated() {
    let flag = true;
    if (!$(".variations_form").valid()) {
      flag = false
    }
    jQuery('.variations select').each((index, elem) => {
      if (!jQuery(elem).val().length) {
        jQuery(elem).addClass('')
        flag = false
      }
    })
    return flag
  }

  $(document).ready(function () {
    $(".variations_form").validate({
      ignore: '.input-text.qty',
      submitHandler: function (form) {
        sendInquiry(form)
      }
    })
    $('.variations_form').on('keyup', 'input', function () {
      const variation_check = $('.variation_id').val().length && $('.variation_id').val() != 0
      $('.btn-inquiry').toggleClass('disabled wc-variation-selection-needed', !($(".variations_form").valid() && variation_check))
    })

    window.variationsSelect.on("select2:close", function (e) {
      const variation_check = $('.variation_id').val().length && $('.variation_id').val() != 0
      $('.btn-inquiry').toggleClass('disabled wc-variation-selection-needed', !$(".variations_form").valid() || !variation_check);
    });

    jQuery('form.variations_form').on( 'click', '.reset_variations', function(e) {
      setTimeout(function() {
        jQuery('.reset_variations').addClass('d-none')
        jQuery('.variation-select-needed-notice').removeClass('d-none')
        jQuery('.btn-inquiry')
          .addClass('disabled wc-variation-selection-needed')
      }, 200)

    })

    $('.btn-inquiry').on('click', function () {
      if ($(this).hasClass('wc-variation-selection-needed')) {
        jQuery('.main-section-shop .variations select').each(function(index, elem) {
          if (jQuery(elem).val() == '') {
            var $elem = jQuery(elem).next().find('.select2-selection__rendered')

            $elem.css('box-shadow', '0px 0px 2px 1px transparent')
            $elem.css('transition', 'box-shadow 0.3s ease')
            $elem.css('box-shadow', '0px 0px 2px 1px #ff4445')

            setTimeout(function() {
              $elem.css('box-shadow', '0px 0px 2px 1px transparent')
            }, 1000)
          }
        })
        console.log(variationFormValidated())
        $('form.variations_form').trigger('onAddToCart')
        return false
      }
      $('.btn-inquiry').data('label', $('.btn-inquiry').text())
      $('.btn-inquiry').addClass('disabled wc-variation-selection-needed btn--loading').html('<span class="material-icons">\n' +
        'loop\n' +
        '</span>')
      $('.variations_form').submit()
    })
  })
})
